import React, { useState } from "react";
import Container from "../ui/Container";
import Card from "../ui/Card";
import { ChevronDown } from "lucide-react";

function QA({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <Card className="p-0 overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
      >
        <div className="text-sm font-semibold text-white">{q}</div>
        <ChevronDown className={`h-5 w-5 text-white/60 transition ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="px-6 pb-6 text-sm leading-6 text-white/65">{a}</div>}
    </Card>
  );
}

export default function DedicatedFAQ() {
  const items = [
    { q: "Can I get a custom configuration?", a: "Yes. If you need specific CPU/RAM/storage, message support and we’ll quote a custom build based on availability." },
    { q: "Do you offer managed dedicated servers?", a: "Optional management is available depending on workload. Ask support and we’ll recommend the right level." },
    { q: "Do prepaid discounts apply?", a: "Yes — 3, 6, and 12 month prepay discounts apply to dedicated servers the same as game hosting." },
    { q: "What about DDoS protection?", a: "Baseline DDoS protection is included. If you need higher thresholds, we can discuss advanced mitigation." },
  ];

  return (
    <section className="bg-[#070A0F] py-20">
      <Container>
        <div className="mx-auto max-w-4xl text-center">
          <div className="text-xs font-semibold tracking-wider text-white/50">FAQ</div>
          <h2 className="mt-3 text-balance text-4xl font-semibold leading-[0.95] tracking-tight text-white sm:text-5xl">
            Dedicated questions<span className="text-cyan-300">.</span>
          </h2>
        </div>

        <div className="mt-14 mx-auto max-w-3xl space-y-4">
          {items.map((it) => (
            <QA key={it.q} q={it.q} a={it.a} />
          ))}
        </div>
      </Container>
    </section>
  );
}
